export default function Company() {
  return(
    <div className="company">
      <p className="mission-statement">Mission Statement:  To enrich our community by inspiring, educating and intellectually stimulating the public through modern dance performance as well as nurturing artistic collaborations.  Reaching past the edge of status quo to invest in innovative ideas that challenge not just the way we view dance, but the world.</p>
      <p className="non-profit">ArtistEDGE dance company is a 501 (3)(C) non-profit corporation registered in the State of California.  The company rehearses in Palo Alto and performs all over the San Francisco/Monterey  Bay Area. 
      </p>
    </div>
  );
}
